import { Controller } from "@hotwired/stimulus"
import tomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    allowBlank: { type: Boolean, default: false },
    enableControlInput: { type: Boolean, default: false }
  }

  connect() {

    const plugins = ['input_autogrow'];

    const options = {
      allowEmptyOption: this.allowBlankValue,
      plugins: plugins
    };

    if (!this.enableControlInputValue) {
      options.controlInput = null;
    }

    new tomSelect(this.element, options);
  }
}
